"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyBillingPeriodItem = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../shared/core");
var BillingPeriod_1 = require("../../../../components/BillingPeriod");
var DownloadButton_1 = require("../../../../components/DownloadButton");
var constants_1 = require("../../../../constants");
var copy_1 = require("../../../../copy");
var handle_bill_download_1 = require("../../../../utils/handle-bill-download");
var HistoryActions_1 = require("./HistoryActions");
exports.LegacyBillingPeriodItem = (0, react_1.memo)(function (_a) {
    var period = _a.period;
    var accountId = (0, ui_tools_1.useAccountContext)().accountId;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var _b = (0, core_1.useComponents)(), Card = _b.Card, P = _b.P;
    var migratedStatementDownload = (0, core_1.useLinks)().migratedStatementDownload;
    var charges = period.chargeTotalPence != null
        ? (0, core_1.minorToMajor)(period.chargeTotalPence)
        : undefined;
    var payments = period.paymentTotalPence != null
        ? [
            {
                description: copy('totalPaymentsLabel'),
                credit: { pounds: (0, core_1.minorToMajor)(period.paymentTotalPence) },
            },
        ]
        : [];
    return (react_1.default.createElement("div", { "data-testid": constants_1.LEGACY_BILLING_PERIOD_SUMMARY_TEST_ID },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(BillingPeriod_1.BillingPeriod, { id: period.statementId, start: period.startDate, end: period.endDate, totalCharges: charges, payments: payments }),
            react_1.default.createElement(HistoryActions_1.HistoryActions, { as: P }, accountId && (react_1.default.createElement(core_1.Feature, { feature: "osv1Download" }, function (enabled) {
                return enabled ? (react_1.default.createElement(DownloadButton_1.DownloadButton, { endDate: period.endDate, downloadUrl: migratedStatementDownload({
                        accountId: accountId,
                        statementId: period.statementId,
                    }), handleDownloadClick: function () {
                        (0, handle_bill_download_1.handleDownloadBillClick)(migratedStatementDownload({
                            accountId: accountId,
                            statementId: period.statementId,
                        }), period.startDate, period.endDate);
                    }, asText: true })) : (react_1.default.createElement(DownloadButton_1.DownloadButton, { endDate: period.endDate, downloadUrl: migratedStatementDownload({
                        accountId: accountId,
                        statementId: period.statementId,
                    }), asText: true }));
            }))))));
});
